<template>
  <div>
    <CRow class>
      <CCol sm="9" class="h-100">
        <h4 class>
          {{ $t('settings.security.component.phoneNumber.title') }}
          <span v-if="!phoneNumberValidated">
            <CIcon
              name="notificationAlert"
              class="text-error"
              size="custom-size"
              :height="15"
              viewBox="0 0 32 32"
              v-c-tooltip="{
                content: $t('settings.security.component.phoneNumber.notValidatedTooltip'),
                placement: 'bottom-start',
              }"
            />
          </span>
        </h4>
        <div class="border-line"></div>
      </CCol>
    </CRow>
    <CRow :gutters="false">
      <CCol sm="12" class="mt-2">
        <p v-if="!phoneNumberValidated" class="text-error">
          {{ $t('settings.security.component.phoneNumber.notValidatedTooltip') }}
        </p>

        <label for="number" class="label-custom required mt-1">
          {{ $t('settings.security.component.phoneNumber.label') }}
        </label>
      </CCol>
      <CCol sm="12">
        <CRow sm="12" class="d-flex" :gutters="false">
          <CCol sm="2" class="mr-1">
            <v-select
              style="max-height: 50px"
              class="mb-0 no-close"
              :options="optionsCountries"
              v-model="$v.countrySelected.$model"
              :value.sync="$v.countrySelected.$model"
              :invalidFeedback="$t('settings.security.component.phoneNumber.invalidFeedback')"
              :isValid="checkIfValid('countrySelected')"
              id="countrySelected"
              :placeholder="$t('general.input.placeholder.country-code')"
              :class="{ 'is-invalid': $v.countrySelected.$error }"
            >
              <template #selected-option="{ label, flag }">
                <div class="d-flex align-items-center">
                  <img :src="flag" alt width="25" />
                  <span class="ml-2">{{ label }}</span>
                </div>
              </template>
              <template v-slot:option="option">
                <img :src="option.flag" width="20" height="auto" />
                {{ option.label }}
              </template>
            </v-select>
            <div class="invalid-feedback" v-if="$v.countrySelected.$error">
              {{ $t('settings.security.component.phoneNumber.invalidFeedback') }}
            </div>
          </CCol>
          <CCol sm="3">
            <CInput
              type="text"
              name="phoneNumber"
              id="phoneNumber"
              addInputClasses="pr-2"
              maxlength="15"
              :value.sync="$v.userPhone.$model"
              :invalidFeedback="$t('settings.security.component.phoneNumber.invalidFeedback')"
              :isValid="checkIfValid('userPhone')"
              @keypress="isNumber($event)"
            />
          </CCol>
        </CRow>
        <CRow class="mt-2">
          <CCol sm="3">
            <CButton type="button" class="py-2 px-5" color="primary" @click="sendSMSToken" :disabled="userButtonSMSValidate">{{
              $t('settings.security.component.phoneNumber.button.validade')
            }}</CButton>
          </CCol>
        </CRow>
        <transition name="fade" v-if="confirmSMSPopUp">
          <div class="dataTable__popUp popUp" style="margin-top: -10px">
            <div class="popUp__body shadow-sm">
              <div class="confirmationDelete">
                <div class="confirmationDelete__header">
                  <p class="confirmationDelete__title font-weight-semi-bold mb-1">
                    {{ $t('settings.security.component.phoneNumber.popup.title') }}
                    <br />
                    {{ $t('settings.security.component.phoneNumber.popup.text') }}
                  </p>
                  <p style="color: #b0b0b0">
                    {{ $t('settings.security.component.phoneNumber.popup.questions') }}
                    <br />
                    <span @click="sendSMSToken" style="text-decoration: underline">
                      {{ $t('settings.security.component.phoneNumber.popup.text2') }}
                    </span>
                  </p>
                </div>
                <div class="confirmationDelete__body mb-4">
                  <input type="text" class="form-control" v-model="validationCodeSMS" />
                </div>
                <div class="confirmationDelete__footer">
                  <div class="confirmationDelete__actions">
                    <CButton color="white" class="py-2 px-5 mr-3" @click="closeConfirmSMSPopUp" type="link">
                      {{ $t('settings.security.component.phoneNumber.popup.button.cancel') }}
                    </CButton>
                    <CButton color="primary" class="py-2 px-5" @click="saveConfirmSMSPopUp">
                      {{ $t('settings.security.component.phoneNumber.popup.button.confirm') }}
                    </CButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import { CallingCodeMoreFlag } from '@/utils/countriesUtils.js'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import services from '@/services.js'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      countrySelected: null,
      userPhone: null,
      userButtonSMSValidate: false,
      confirmSMSPopUp: false,
      phoneNumberValidated: true,
      validationCodeSMS: '',
    }
  },
  mixins: [validationMixin],
  computed: {
    optionsCountries() {
      return CallingCodeMoreFlag(this)
    },
  },
  validations: {
    userPhone: {
      required,
    },
    countrySelected: {
      required,
    },
  },
  mounted() {
    this.getBasicInfo()
  },
  methods: {
    getBasicInfo() {
      let userId = this.$store.state.auth.user.id

      services.getBasicInfo(userId).then((res) => {
        this.userPhone = res.data.data.phoneNumber

        this.optionsCountries.find((el) => el.value == res.data.data.phoneCountryIndicator)
        this.countrySelected = this.optionsCountries.find((el) => el.value == res.data.data.phoneCountryIndicator)
        this.phoneNumberValidated = res.data.data.phoneNumberConfirmed
        this.$emit('phoneConfirmed', res.data.data.phoneNumberConfirmed)
      })
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName]

      if (!field.$dirty) {
        return null
      }
      return !(field.$invalid || null)
    },
    isNumber(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    sendSMSToken() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.confirmSMSPopUp = false
      this.userButtonSMSValidate = true

      let body = {
        phoneCountryIndicator: this.countrySelected.value,
        phoneNumber: this.userPhone,
      }

      let userID = this.$store.state.auth.user.id
      services
        .sendTokenToChangePhone(userID, body)
        .then(() => {
          this.confirmSMSPopUp = true
          this.userPhoneCountryIndicatorSentToken = this.phoneCountryIndicator
          this.userPhoneSentToken = this.userPhone
        })
        .catch((error) => {
          this.$emit('showMessage', {
            status: 'danger',
            text: this.$te(`general.errors.${error.response.data.message}`)
              ? this.$t(`general.errors.${error.response.data.message}`)
              : error.response.data.message,
          })
          this.scrollTop()
          this.userButtonValidate = false
        })
        .finally(() => {
          this.userButtonSMSValidate = false
        })
    },
    saveConfirmSMSPopUp() {
      this.messages = []

      let userID = this.$store.state.auth.user.id

      services
        .updateUserPhone(userID, {
          phoneCountryIndicator: this.countrySelected.value,
          phoneNumber: this.userPhone,
          validationCode: this.validationCodeSMS,
        })
        .then(() => {
          this.$emit('showMessage', {
            status: 'success',
            text: this.$t('settings.security.message.sucess.update-phone'),
          })

          this.userPhone = ''
          this.countrySelected = null
          this.$v.$reset()
          this.getBasicInfo()
        })
        .catch((error) => {
          this.$emit('showMessage', {
            status: 'danger',
            text: this.$te(`general.errors.${error.response.data.message}`)
              ? this.$t(`general.errors.${error.response.data.message}`)
              : error.response.data.message,
          })
        })
        .finally(() => {
          this.confirmSMSPopUp = false
          this.userButtonSMSValidate = false
          this.validationCodeSMS = null
        })
    },
    closeConfirmSMSPopUp() {
      this.confirmSMSPopUp = false
    },
  },
}
</script>
